<em-icon-button
  icon="download_csv"
  color=""
  aria-label="download_csv"
  (btnClick)="downloadClick()"
  matTooltip="{{ 'CSV_DOWNLOAD_TOOLTIP' | translate }}"
></em-icon-button>
